import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorDcaTrading = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M8 3.25a.75.75 0 0 1 .75.75v1.25h6.5V4a.75.75 0 0 1 1.5 0v1.25h1.75a2.25 2.25 0 0 1 2.25 2.25v11a2.25 2.25 0 0 1-2.25 2.25h-13a2.25 2.25 0 0 1-2.25-2.25v-11A2.25 2.25 0 0 1 5.5 5.25h1.75V4A.75.75 0 0 1 8 3.25Zm7.25 3.5h-6.5V8a.75.75 0 0 1-1.5 0V6.75H5.5a.75.75 0 0 0-.75.75v11c0 .414.336.75.75.75h13a.75.75 0 0 0 .75-.75v-11a.75.75 0 0 0-.75-.75h-1.75V8a.75.75 0 0 1-1.5 0V6.75Z"
    />
    <path
      fill="#F7A600"
      d="M16.178 13.84a.75.75 0 1 0 1.453-.374l-.75-2.905a.75.75 0 0 0-.914-.539l-2.905.75a.75.75 0 0 0 .375 1.453l1.18-.305-2.345 3.098-3.517-3.198a.75.75 0 0 0-1.129.139l-1.5 2.25a.75.75 0 0 0 1.248.832l1.017-1.525 3.48 3.164a.75.75 0 0 0 1.102-.102l2.917-3.855.288 1.118Z"
    />
  </svg>
);
export default SvgTwoColorDcaTrading;
